import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_BEGIN,
  DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_SUCCESS,
  DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_FAILURE,
  DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function exportProjectCode(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/code-export`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_SUCCESS,
              data: res.data,
            });
            toast.success('Request Created Successfully');
            resolve(res);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportProjectCodeError() {
  return {
    type: DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_BEGIN:
      return {
        ...state,
        exportProjectCodePending: true,
        exportProjectCodeError: null,
      };

    case DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_SUCCESS:
      return {
        ...state,
        exportProjectCodePending: false,
        exportProjectCodeError: null,
        exportRequestList: action.data,
      };

    case DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_FAILURE:
      return {
        ...state,
        exportProjectCodePending: false,
        exportProjectCodeError: action.data.error,
      };

    case DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_DISMISS_ERROR:
      return {
        ...state,
        exportProjectCodeError: null,
      };

    default:
      return state;
  }
}
